import type { FixingMode } from "@/data/fixingMode";
import type { AssetClass2ByFixingMode } from "@/data/assetClass2ByFixingMode";

/**
 * Default categorisation for price
 */
export const DEFAULT_PRICE_CATEGORISATION: AssetClass2ByFixingMode = {
  valorisation: [],
  NA: [],
};

export function computeFixingMode(assetClass2?: string): FixingMode | null {
  if (!assetClass2) return null;
  const asset_class_2 = assetClass2.trim().toLowerCase();
  if (
    DEFAULT_PRICE_CATEGORISATION.valorisation
      .map((s) => s.toLowerCase())
      .includes(asset_class_2)
  )
    return "valorisation";
  if (
    DEFAULT_PRICE_CATEGORISATION.NA.map((value) =>
      value.toLowerCase(),
    ).includes(asset_class_2)
  )
    return "NA";
  return "fixing";
}

const isFiniteNumber = (v: unknown): boolean =>
  typeof v === "number" && Number.isFinite(v);

export const requiresMarketValue = (data: any) => {
  const assetClass2 = data?.n1_static_datum_asset_class_2 ?? undefined;
  const mode = computeFixingMode(assetClass2);
  return mode !== "valorisation" || isFiniteNumber(data.market_value);
};

export const requiresFixing = (data: any) => {
  const assetClass2 = data?.n1_static_datum_asset_class_2 ?? undefined;
  const mode = computeFixingMode(assetClass2);
  return mode !== "fixing" || isFiniteNumber(data.fixing);
};
